import { ModalProps } from 'antd';
import GuideDialog from './NewbieGuideDialog';
import { useTranslate } from '@tolgee/react';

export interface KwaiShopDialogProps extends ModalProps {
  isConfigService: boolean;
  onConfigService: (e: any) => void;
  initialStoreType?: IM_API.Admin.StoreType;
  initialRegion?: General.UpperCaseRegion;
  initialDepartmentIds?: number[];
}

const KwaiAuthShopDialog = (props: KwaiShopDialogProps) => {
  const { t } = useTranslate();

  return (
    <GuideDialog
      defaultPlatform="kwai"
      defaultTitle={t('添加Mercado店铺').replace('Mercado', 'Kwai')}
      {...props}
      closable
      maskClosable={false}
    />
  );
};

export default KwaiAuthShopDialog;
